/**
 * The gated download's memory.
 *
 * Shopify's customer form round-trips the page, so the reveal after a
 * submission is server-rendered. This only covers the second visit: someone
 * who has already given an address should not be asked again, so the fact
 * that they did is kept in this browser.
 *
 * It is a convenience, not a check. The file is at a public URL either way,
 * and the section's comment says so.
 */
(() => {
  for (const gate of document.querySelectorAll('[data-dopa-gate]')) {
    const key = 'dopa-gate:' + (gate.dataset.gateKey || 'default');
    const ask = gate.querySelector('[data-dopa-gate-ask]');
    const reveal = gate.querySelector('[data-dopa-gate-reveal]');
    if (!reveal) continue;

    const remember = () => {
      try { localStorage.setItem(key, '1'); } catch { /* private window, nothing to do */ }
    };

    // Server said yes on this load: remember it and leave the markup alone.
    if (!reveal.hidden) {
      remember();
      continue;
    }

    let given = false;
    try { given = localStorage.getItem(key) === '1'; } catch { given = false; }

    if (given) {
      reveal.hidden = false;
      if (ask) ask.hidden = true;
    } else if (ask) {
      // Record the intent at submit, so the reveal survives the round trip
      // even if the customer form redirects somewhere unexpected.
      ask.addEventListener('submit', remember);
    }
  }
})();
